module.exports = __webpack_public_path__ + "img/1-1.9f9d03e8.png";